/**
 * Who someone is in Site Wallet terms, from the same facts the server uses
 * (housingram-backend src/modules/siteWallet/rules.ts):
 *
 * - builder side: the owner, the Management vertical, or level High. Creates
 *   wallets, adds money, freezes, settles, manages categories.
 * - Accounts: the Accounts vertical. Approves expenses on their projects, adds
 *   money to wallets, pays reimbursements.
 * - holder: Operations at level Medium (Manager) or Low (Executive).
 *
 * Only used to hide what the server would refuse; the server still decides.
 */
export function siteWalletRoleFor({ vertical, level, isOwner = false } = {}) {
  const v = String(vertical || '').toLowerCase();
  const l = String(level || '').toLowerCase();
  const builderSide = Boolean(isOwner) || v === 'management' || l === 'high';
  const isAccounts = v === 'accounts';
  return {
    builderSide,
    isAccounts,
    // Wallets (and Add money), approvals, reimbursements and reports.
    isStaff: builderSide || isAccounts,
    mayHoldWallet: v === 'operations' && (l === 'medium' || l === 'low')
  };
}
